import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import toast from "react-simple-toasts";
import styled from "styled-components";
import Navbar from "../../Components/Navbar";
import { ButtonInput } from "../../Components/reusable_components";
import { ToastTimer } from "../../data";
import { auth, fireStoredb } from "../../firebase_config";

const PostBody = styled.div`
  width: 80%;
  height: calc(100vh - 150px);
  margin: auto;
  overflow: hidden;
`;

const PostCollection = styled.div`
  width: 50%;
  margin: auto;
  overflow: scroll;
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  @media screen and (max-width: 770px) {
    width: 100%;
  }
  /* background-color: white; */
`;

const PostCollectionWrapper = styled.div`
  width: 100%;
  height: auto;
`;

const Cards = styled.div`
  width: 90%;
  height: 480px;
  padding: 20px;

  border: 1px solid #693b93;
  margin: 20px auto;
`;
const CardHeader = styled.div`
  width: 100%;
  height: auto;
  /* background-color: green; */
`;
const AvatarWrapper = styled.div`
  width: 30%;
  min-width: 100px;
  height: auto;
  margin: 5px;
  /* background-color: #30114d; */
`;
const UserContent = styled.div`
  width: 70%;
  height: auto;
  /* background-color: green; */
`;
const AvatarImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 3px;
  object-fit: contain;

  padding: 5px;
`;
const UserNameWrapper = styled.div`
  width: 80%;
  height: auto;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fff;
  text-transform: capitalize;
  white-space: nowrap;
`;
const CardBody = styled.div`
  width: 100%;
  height: 60%;
  margin: 10px auto;
  background-color: #693b93;
`;
const PostImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const CardFooter = styled.div`
  width: 100%;
  height: auto;
`;
const Caption = styled.div`
  width: 100%;
  height: 52px;
  color: #fff;
  font-size: 13px;
  overflow: hidden;
`;
const Admin = () => {
  const [userPostData, setuserPostData] = useState([]);
  useEffect(() => {
    const gettingPostsData = async () => {
      try {
        const q = query(
          collection(fireStoredb, "posts"),
          where("visible", "==", false),
          orderBy("createdAt", "desc")
        );

        let productwithUser = [];
        onSnapshot(q, (querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            let newItem = { id: doc.id, ...doc.data() };
            if (newItem.userRef) {
              let userData = await getDoc(newItem.userRef);
              if (userData.exists()) {
                newItem.userData = { userID: userData.id, ...userData.data() };
              }

              setuserPostData([newItem, ...userPostData]);
            } else {
              productwithUser.push(newItem);
            }
          });
        });
      } catch (err) {
        console.log(err);
        toast(err.message, ToastTimer);
      }
    };
    auth.currentUser?.uid && gettingPostsData();
  }, []);
  console.log(userPostData);
  return (
    <>
      <Navbar />
      <PostBody className="d-flex">
        <PostCollection>
          <PostCollectionWrapper>
            {userPostData.map((d, index) => (
              <PostCollectionCard data={d} key={index} />
            ))}
          </PostCollectionWrapper>
        </PostCollection>
      </PostBody>
    </>
  );
};

const PostCollectionCard = ({ data }) => {
  const handleVisible = async (id) => {
    try {
      const docRef = doc(fireStoredb, "posts", id);

      // Set the "capital" field of the city 'DC'
      await updateDoc(docRef, {
        visible: true,
      });
      toast("Data updated..", ToastTimer);
    } catch (error) {
      toast(error.message, ToastTimer);
    }
  };
  const handleDelete = async (id) => {
    try {
      const docRef = doc(fireStoredb, "posts", id);

      // Set the "capital" field of the city 'DC'
      await deleteDoc(docRef);
      toast("Data Deleted..", ToastTimer);
    } catch (error) {
      toast(error.message, ToastTimer);
    }
  };
  return (
    <Cards>
      <CardHeader className="d-flex justify-between align-center">
        <AvatarWrapper className="d-flex justify-center align-center">
          <AvatarImage src={data?.userData.avatar} />
        </AvatarWrapper>
        <UserContent>
          <UserNameWrapper className="d-flex justify-center align-center">
            {data?.userData.username}
          </UserNameWrapper>
        </UserContent>
      </CardHeader>
      <CardBody>
        <PostImage src={data.imagePath} />
      </CardBody>
      <CardFooter>
        <div className="d-flex">
          <ButtonInput value="Visible" onClick={() => handleVisible(data.id)} />
          <ButtonInput value="delete" onClick={() => handleDelete(data.id)} />
        </div>
        <Caption>
          <p>
            <strong style={{ fontSize: "16px" }}>{data.username} </strong>
            {data.caption}
          </p>
        </Caption>
      </CardFooter>
    </Cards>
  );
};
export default Admin;
